import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="flash".
export default class extends Controller {
  connect() {
    // Somehow, adding the class needs to be done via a timeout.
    window.setTimeout(() => this.element.classList.add('show'), 1);
    window.setTimeout(() => this.element.classList.remove('show'), 5000);
  }
};
